<template>
	<div>
		<case-form :schema="schema" />
	</div>
</template>

<script>
import CaseForm from "@/modules/caseManagement/components/CaseForm/CaseForm.vue"
export default {
	components: {
		CaseForm
	},

	data() {
		return {
			maxNumberOfList: 3
		}
	},

	computed: {
		schema() {
			return [
				{
					label: "在填写此调查表时，您是否按照第三方的指示行事？",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasThidPartyInstructionsCN`,
					props: {
						suggest: {
							typeIncludes: `hasThidPartyInstructionsCN`
						},
						createOptions: {
							type: `hasThidPartyInstructionsCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "个人，公司或组织的名称",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0thirdPartyNameCN`,
					props: {
						suggest: {
							typeIncludes: `thirdPartyNameCN`
						},
						createOptions: {
							type: `thirdPartyNameCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "出生日期",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0thirdPartyDOBCN`,
					props: {
						suggest: {
							typeIncludes: `thirdPartyDOBCN`
						},
						createOptions: {
							type: `thirdPartyDOBCN`,
							dataType: "date"
						}
					}
				},
				{
					label: "公司编号 ",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0thirdPartyINCNoCN`,
					props: {
						suggest: {
							typeIncludes: `thirdPartyINCNoCN`
						},
						createOptions: {
							type: `thirdPartyINCNoCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "注册管辖权",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0thirdPartyJurisdictionOfRegistrationCN`,
					props: {
						suggest: {
							typeIncludes: `thirdPartyJurisdictionOfRegistrationCN`
						},
						createOptions: {
							type: `thirdPartyJurisdictionOfRegistrationCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "地址",
					component: "entityAddress",
					entity: "case.holder",
					relation: "case.insureds[0].addresses",
					bindTo: "case.facts.insured0thirdPartyPrimaryAddressCN",
					props: {
						suggest: {
							typeIncludes: "thirdPartyPrimaryAddressCN"
						},
						createOptions: {
							type: "thirdPartyPrimaryAddressCN"
						}
					}
				},
				{
					label: "该个人，公司或组织的主要业务或职业",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0thirdPartyBusinessOrOccupation`,
					props: {
						suggest: {
							typeIncludes: `thirdPartyBusinessOrOccupationCN`
						},
						createOptions: {
							type: `thirdPartyBusinessOrOccupationCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "与被保险人关系",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0thirdPartyRelationshipCN`,
					props: {
						suggest: {
							typeIncludes: `thirdPartyRelationshipCN`
						},
						createOptions: {
							type: `thirdPartyRelationshipCN`,
							dataType: "string"
						}
					}
				}
			]
		}
	}
}
</script>
